import { type ReactNode } from 'react';
import Tooltip from 'src/modules/shared/components/atoms/tooltips/tooltip';
import { classes } from 'src/modules/shared/utils/styles.util';
import type {
  ComponentAppearance,
  ComponentVariant,
} from 'src/modules/shared/types/component.type';
import { resolveVariantClasses } from 'src/modules/shared/styles/variant-classes';

type IconBadgeSize = '2xs' | 'xs' | 'sm' | 'md' | 'lg';

const SIZE_CLASS_MAP: Record<IconBadgeSize, string> = {
  '2xs': 'h-5 w-5 text-[0.625rem]',
  xs: 'h-6 w-6 text-[0.75rem]',
  sm: 'h-7 w-7 text-[0.875rem]',
  md: 'h-8 w-8 text-[1rem]',
  lg: 'h-10 w-10 text-[1.125rem]',
};

interface IconBadgeProps {
  icon: ReactNode;
  size?: IconBadgeSize;
  variant?: ComponentVariant;
  appearance?: ComponentAppearance;
  tooltip?: string;
  className?: string;
}

export const IconBadge: React.FC<IconBadgeProps> = ({
  icon,
  size = 'sm',
  variant = 'primary',
  appearance = 'soft',
  tooltip,
  className,
}) => {
  const content = (
    <div
      className={classes(
        'flex items-center justify-center rounded-full border shadow-sm transition-colors duration-150',
        SIZE_CLASS_MAP[size],
        resolveVariantClasses(variant, appearance),
        className
      )}
    >
      {icon}
    </div>
  );

  if (tooltip) {
    return (
      <Tooltip size="sm" content={tooltip} placement="top">
        {content}
      </Tooltip>
    );
  }

  return content;
};
